<template>
  <BaseModal :visible="visible" @close="handleClose">
    <div class="taskModal" :style="bgStyle">
      <div class="title" :style="titleColorStyle">
        {{ titleText }}
      </div>
      <div class="countdown" :style="titleColorStyle">
        <Countdown :leftMillsec="taskRemainMillSec" @timeend="handleTimeend" />
      </div>
      <div class="valueBlock" :style="valueBlockColorStyle">
        <div class="unit">&yen;</div>
        <div class="amount">{{ awardTotalValue | centToYuan }}</div>
        <div class="detailBtn"></div>
      </div>
      <InviteProgress
        class="progress"
        :total="taskInfo.total"
        :current="taskInfo.current"
        :inviteeInfos="taskInfo.inviteeInfos"
        :emptyAvatarImage="emptyAvatarImage"
        :defaultAvatarImage="defaultAvatarImage"
        @click="handleClickProgress"
        showPhoneNumber
      />
      <div
        class="primaryBtn"
        :style="primaryBtnStyle"
        @click="handleLaunchInvite"
      >
        {{ btnText }}
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal';
import InviteProgress from './InviteProgress.vue';
import { centToYuan } from '@/components/templates/helper';
import { mapMutations, mapState } from 'vuex';
import Countdown from './Countdown';

export default {
  components: { BaseModal, InviteProgress, Countdown },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    awardTotalValue: {
      type: Number,
      require: true
    },
    // 默认头像
    defaultAvatarImage: String,
    // 空态头像
    emptyAvatarImage: String,
    taskInfo: {
      type: Object,
      require: true
    }
  },
  watch: {
    visible(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.$emit('reportExpoEvent', {
          event: 'boost_coupon_invite_expo',
          module_name: '启动页弹窗'
        });
      }
    }
  },
  computed: {
    ...mapState('app/inviteEarnCoupon/inviter', {
      modalConfig: state => {
        return state.modalConfig || {};
      }
    }),
    taskRemainMillSec() {
      return this.taskInfo.endTime - this.taskInfo.currentTime;
    },
    bgStyle() {
      return {
        background: `center / cover url("${this.modalConfig.backgroundImage}") no-repeat`
      };
    },
    titleColorStyle() {
      return {
        color: this.modalConfig.titleFontColor
      };
    },
    valueBlockColorStyle() {
      return {
        color: this.modalConfig.amountFontColor
      };
    },
    primaryBtnStyle() {
      return {
        background: `center / cover url("${this.modalConfig.buttonBackgroundImage}") no-repeat`,
        color: this.modalConfig.buttonFontColor
      };
    },
    inviteRequireLeft() {
      return (
        this.taskInfo &&
        Number(this.taskInfo.total) - Number(this.taskInfo.current)
      );
    },
    isNoInviteYet() {
      // 是否还没有邀请
      return this.taskInfo && this.taskInfo.current === 0;
    },
    titleText() {
      return `${this.isNoInviteYet ? '' : '再'}邀请 ${
        this.inviteRequireLeft
      } 位好友立即领取礼包`;
    },
    btnText() {
      return `${this.isNoInviteYet ? '' : '再'}邀 ${
        this.inviteRequireLeft
      } 人立即领取`;
    }
  },
  methods: {
    ...mapMutations('app/inviteEarnCoupon/inviter', ['toggleTaskModal']),
    handleClose() {
      this.toggleTaskModal(false);
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: '启动页弹窗',
        button_name: '退出icon'
      });
    },
    handleLaunchInvite() {
      this.$emit('launchInvite');
      this.toggleTaskModal(false);
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: '启动页弹窗',
        button_name: `邀${this.inviteRequireLeft}人立即领取`
      });
    },
    handleClickProgress(type) {
      if (type === 'add') {
        this.$emit('launchInvite');
        this.toggleTaskModal(false);
        this.$emit('reportEvent', {
          event: 'boost_coupon_popup_invite_click',
          module_name: '启动页弹窗',
          button_name: '邀请加号'
        });
      }
    },
    handleTimeend() {
      this.toggleTaskModal(false);
    }
  },
  filters: {
    centToYuan
  }
};
</script>

<style lang="less" scoped>
.taskModal {
  width: 582px;
  height: 682px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 40px;
  border-radius: 16px;
  color: #ffffff;

  .title {
    font-size: 38px;
  }

  .countdown {
    margin-top: 5px;
    font-size: 28px;
  }

  .valueBlock {
    position: absolute;
    top: 210px;
    left: 50%;
    transform: translateX(-50%);
    color: #ff0044;
    font-family: 'Alibaba Zhixing';
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .unit {
      align-self: flex-end;
      margin-bottom: 7px;
      font-size: 60px;
    }
    .amount {
      font-size: 120px;
    }
  }

  .progress {
    position: absolute;
    top: 440px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 542px;
  }

  .primaryBtn {
    position: absolute;
    bottom: 38px;
    left: 50%;
    transform: translateX(-50%);
    width: 500px;
    height: 98px;
    border-radius: 49px;
    font-size: 40px;
    color: #ffffff;
    line-height: normal;
    .fc;
  }
}
</style>
